<script>
import resources from './resources'

export default {
  name: 'professional-graduations',
  mixins: [resources]
}
</script>

<template lang="pug">
  .row(style="margin-top: 10px; margin-bottom: 20px;")
    .col-xs-12.col-sm-6.margin-bottom
      small.grey Especialização
      br
      span#professionalName.blue(style="font-size: 15px;") {{ specialization.area }}
      small.grey Área de Especialidade
      br
      span#professionalName.blue(style="font-size: 15px;") {{ specialization.specialities.name }}

    .col-xs-12.col-sm-6.margin-bottom
      small.grey Instituição de Ensino
      br
      span#professionalName.blue(style="font-size: 15px;") {{ specialization.entity_name }}
      small.grey(v-if="specializationStart != 'Invalid date' && specializationEnd != 'Invalid date'") Período
      br
      span#professionalName.blue(style="font-size: 15px;", v-if="specializationStart != 'Invalid date' && specializationEnd != 'Invalid date'") {{ specializationStart }} &mdash; {{ specializationEnd }}

</template>



// WEBPACK FOOTER //
// src/app/patient/agendas/search/results/components/professional/components/specializations/specialization.vue